module.exports = __webpack_public_path__ + "9a3b4b62a3af315038e3eb6765a783c5.png";